import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Trash2, Plus, ArrowUp, ArrowDown } from 'lucide-react';
import { api } from '../../lib/api';
import { useSite } from '../../context/SiteContext';

function Side({ title, items, setItems, testIdPrefix }) {
    const update = (i, k, v) => setItems(items.map((it, idx) => idx === i ? { ...it, [k]: v } : it));
    const remove = (i) => setItems(items.filter((_, idx) => idx !== i));
    const move = (i, dir) => {
        const j = i + dir; if (j < 0 || j >= items.length) return;
        const next = [...items]; [next[i], next[j]] = [next[j], next[i]];
        setItems(next.map((it, idx) => ({ ...it, order: idx })));
    };
    const add = () => setItems([...items, { label: 'New Link', href: '/', order: items.length }]);
    return (
        <div className="luxury-card p-5">
            <div className="flex items-center justify-between mb-3">
                <h3 className="font-serif text-xl" style={{ color: 'var(--brand-burgundy)' }}>{title}</h3>
                <button onClick={add} data-testid={`${testIdPrefix}-add`} className="btn-outline-burgundy px-3 py-1.5 rounded-lg text-xs uppercase tracking-[0.18em] inline-flex items-center gap-1"><Plus className="w-3 h-3" /> Add</button>
            </div>
            <ul className="space-y-2">
                {items.map((it, i) => (
                    <li key={i} className="flex flex-col sm:flex-row sm:items-center gap-2">
                        <div className="flex flex-col sm:flex-row gap-2 flex-1 w-full min-w-0">
                            <input className="input-luxury flex-1 min-w-0" placeholder="Label" value={it.label} onChange={(e) => update(i, 'label', e.target.value)} />
                            <input className="input-luxury flex-1 min-w-0" placeholder="/path" value={it.href} onChange={(e) => update(i, 'href', e.target.value)} />
                        </div>
                        <div className="flex items-center gap-1 self-end sm:self-auto flex-shrink-0">
                            <button onClick={() => move(i, -1)} className="p-1.5 hover:bg-[var(--brand-rose)]/40 rounded"><ArrowUp className="w-4 h-4" /></button>
                            <button onClick={() => move(i, 1)} className="p-1.5 hover:bg-[var(--brand-rose)]/40 rounded"><ArrowDown className="w-4 h-4" /></button>
                            <button onClick={() => remove(i)} className="p-1.5 hover:bg-[var(--brand-rose)]/40 rounded"><Trash2 className="w-4 h-4" style={{ color: 'var(--brand-burgundy)' }} /></button>
                        </div>
                    </li>
                ))}
                {items.length === 0 && <li className="text-xs" style={{ color: 'var(--ink-muted)' }}>No links.</li>}
            </ul>
        </div>
    );
}

export default function AdminNavigation() {
    const { navigation, refresh } = useSite();
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => { if (navigation) { setLeft(navigation.left || []); setRight(navigation.right || []); } }, [navigation]);

    const save = async () => {
        setSaving(true);
        try {
            await api.put('/admin/navigation', {
                left: left.map((it, i) => ({ ...it, order: i })),
                right: right.map((it, i) => ({ ...it, order: i })),
            });
            toast.success('Navigation updated.'); await refresh();
        } catch { toast.error('Save failed'); } finally { setSaving(false); }
    };

    return (
        <div data-testid="admin-navigation-page">
            <div className="flex items-center justify-between mb-8">
                <div>
                    <p className="eyebrow" style={{ color: 'var(--brand-burgundy)' }}>Atelier</p>
                    <h1 className="font-serif text-4xl mt-1" style={{ color: 'var(--brand-burgundy)' }}>Navigation</h1>
                </div>
                <button onClick={save} disabled={saving} data-testid="admin-navigation-save" className="btn-burgundy px-5 py-2.5 rounded-xl text-xs uppercase tracking-[0.18em] disabled:opacity-60">{saving ? 'Saving...' : 'Save Navigation'}</button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <Side title="Left of Logo" items={left} setItems={setLeft} testIdPrefix="admin-nav-left" />
                <Side title="Right of Logo" items={right} setItems={setRight} testIdPrefix="admin-nav-right" />
            </div>
        </div>
    );
}
